import { useState } from "react";

const useForm = (initialState = {}, validators = []) => {
  const [values, setValues] = useState(initialState);

  const setFormData = ({ target }) => {
    setValues({ ...values, [target.name]: target.value });
  };

  const validateFormData = () => {
    let validationErrors = {};
    validators.forEach((validator) => {
      const result = validator(values);
      if (typeof result === "object") {
        validationErrors = { ...validationErrors, ...result };
      }
    });
    return validationErrors;
  };
  return { values, setFormData, validateFormData };
};

export default useForm;
